<template>
<div>

    <div
        class="content-wrapper"
        style="min-height: 873px;"
    >
        <div>
            <section class="content">

                <div class="row">
                    <!-- Left col -->
                    <section class="col-lg-8 connectedSortable">

                        <!-- /.nav-tabs-custom -->

                        <div class="box">
                            <div class="box-header">

                                <div class="row">
                                    <div class="col col-sm-6">
                                        <h1 class="box-title">{{$t('TRANSACTIONS_DETAILS')}} #{{ transaction.Authorization_Id }}</h1>
                                    </div>

                                    <div class="col col-sm-6">
                                        <div
                                            class="primary"
                                            style="text-align:right;"
                                        >
                                            <button
                                                style="font-size:40px;"
                                                class="btn btn-default"
                                                v-bind:class="transaction.estatus | checkStatus"
                                            ></button>
                                    </div>
                                </div>


                            </div>

                        </div>
                        <!-- /.box-header -->

                        <div class="box-body">

                            <div v-if="loading == false">
                                <th>{{$t('TRANSACTION_TABLE.COLUMS.ENTITY_NAME')}}:</th>
                                <h3>{{ transaction.Entity_Name }}</h3>
                                <br>
                                <th>{{$t('TRANSACTION_TABLE.COLUMS.ENTITY_ID')}}:</th>
                                <h3>{{ transaction.Entity_Id }}</h3>
                                <br>
                                <th>{{$t('CREDIRCARD_OWNER') }}:</th>
                                <h3>{{ transaction.CardHolder }}</h3>
                                <br>
                                <th>{{$t('TRANSACTION_TABLE.COLUMS.APPROVED_AMOUNT')}}:</th>
                                <h3>{{ transaction.Aproved_Amount | Decimal }}</h3>
                                <br>
                                <th>{{$t('TRANSACTION_TABLE.COLUMS.AMOUNT_REQUESTED')}}:</th>
                                <h3>{{ transaction.Amount | Decimal }}</h3>
                                <br>
                                <th>{{ $t('TRANSACTION_TABLE.COLUMS.TRANSACTION_ID')}}:</th>
                                <h3>{{ transaction.Authorization_Id }}</h3>
                                <br>
                                <th>{{$t('TRANSACTION_TABLE.COLUMS.TRANSACTION_TYPE') }}:</th>
                                <h3>{{ transaction.Transaction_Type }}</h3>
                                <br>
                                <th>{{ $t('TRANSACTION_TABLE.COLUMS.DATE')}}:</th>
                                <h3>{{ transaction.Transaction_Date | formatDate }}</h3>
                                <br>


                                <button
                                    class="btn btn-primary"
                                    type="button"
                                    @click="doPetition( transaction.Entity_Id,  transaction.Authorization_Id )"
                                >{{btn_text | translate }}</button>
                                    <button
                                        class="btn btn-default"
                                        @click="back"
                                    >{{ $t('CANCEL')}}</button>
                            </div>
                            <div v-else>
                                <center>
                                    <div
                                        class="fa fa-spinner fa-spin"
                                        style="font-size:100px;"
                                    ></div>
                            </center>
                        </div>

                </div>
        </div>

        </section>

</div>
</section>

</div>
</div>
</div>
</template>

<script>
import swal from "sweetalert";

export default {
    name: "TransactionDetails",

    mounted() {
        this.getOne(this.$route.params.id);
    },
    data() {
        return {
            loading: false,
            transaction: {},
            btn_text: 'REQUEST_REFUND'
        };
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        async getOne(id) {
            let self = this;

            try {
                self.loading = true;
                let response = await self.$store.state.services.transactionService.getOne(
                    id,
                    JSON.parse(self.$store.getters.user).token
                
                );

                if (response.data.estatus == 'Aprobado') self.btn_text = 'MAKE_REFOUND';
                if (response.data.estatus == 'Pendiente') self.btn_text = 'RESEND_REQUEST';
                self.transaction = response.data;

                
            } catch (reason) {
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                });
            }finally{
                self.loading = false;
            }
        },
        doPetition(Entity_Id, Transaction_id) {
            let self = this;

            swal({
                title: this.$t("ARE_YOU_SURE?"),
                text: this.$t('DETAILQUESTION'),
                icon: "warning",
                buttons: [ this.$t("No, CANCEL"), this.$t('YES, CONTINUE') ],
                dangerMode: true
            }).then(async willDelete => {
                if (willDelete) {
                    try {
                        
                        self.loading = true;
                        let response = await self.$store.state.services.transactionService.sendEmailRequest(
                            Transaction_id,
                            Entity_Id,
                            JSON.parse(self.$store.getters.user).token
                        );
                        self.loading = false;
                        swal(response.data.message, {
                            icon: response.data.icon
                        });

                    } catch (reason) {
                      //console.log({reason})
                        swal({
                            title: this.$t("ERROR REQUEST DID NOT SEND"),
                            text:`${this.$t("REASON")}: ${reason.response.data.error}`,
                            icon: "error"
                        });
                    }finally{
                        self.loading = false;
                    }
                } else {
                    swal(this.$t("PETITION NOT REALIZED"));
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/TransactionDetails.vue